// removed by extract-text-webpack-plugin
module.exports = {"small":"(min-width:600px)","medium":"(min-width:768px)","medium-large":"(min-width:1024px)","large":"(min-width:1200px)","extra-large":"(min-width:1400px)","wide":"(min-width:1600px)","easeOutQuad":"cubic-bezier(.25,.46,.45,.94)","easeInQuad":"cubic-bezier(.55,.085,.68,.53)","slideShow":"slideshow__slideShow___VPekV","enter":"slideshow__enter___2Smwz","enterActive":"slideshow__enterActive___1I3Ge","leave":"slideshow__leave___UPGFs","leaveActive":"slideshow__leaveActive___3dLSQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SlideShow/slideshow.css
// module id = 165
// module chunks = 0